import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicStyleLoaderService } from '../../utilities/dynamic-style-loader';

@Component({
    selector: 'app-disability',
    templateUrl: './disability.component.html',
    styleUrls: ['./disability.component.scss'],
    standalone: false
})
export class DisabilityComponent implements OnInit {

  dialogData:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dynamicStyleLoader: DynamicStyleLoaderService) {
    this.dialogData = data.parentInstance;
   } 

  ngOnInit(): void {
    this.dynamicStyleLoader.focusCloseButton('mob-focus-disability', 'desktop-focus-disability');  
  }

}
